import 'whatwg-fetch';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, IndexRoute, browserHistory, IndexRedirect } from 'react-router';
import { UserAuthWrapper } from 'redux-auth-wrapper';
import some from 'lodash.some';

import { Provider } from 'react-redux';
import store from './createStore';

import auth from './auth';
import injectTapEventPlugin from 'react-tap-event-plugin';
import { Paper } from 'material-ui';
import App from './components/App';
import FAQ from './components/FAQ';
import I18 from './components/I18';
import Home from './components/Home';
import WidgetListStats from './components/WidgetListStatsByUser';
import LoginForm from './components/LoginForm';
import Account from './components/account/Account';
import AccountDefaults from './components/account/AccountDefaults';
import AccountPassword from './components/account/AccountPassword';

import WidgetPick from './components/WidgetPick';
import WidgetCustomizer from './components/WidgetCustomizer';
import WidgetDemo from './components/WidgetDemo';
import ThemesList from './components/ThemesList';
import ThemeCustomizer from './components/ThemeCustomizer';
import ImageUploaderContainer from './components/ImageUploaderContainer';
import TvProgramDashboard from './components/TvProgramDashboard';
import GridMakerToolPage from './grid-maker-tool-page/components/index';
import PlayerPerformanceIndex from './ppi/components/PlayerPerformanceIndex';
import PacksScene from './packs/components/PacksScene';
import PacksList from './packs/components/PacksList';
import Pack from './packs/components/Pack';
import UsersPacksDashboard from './components/UsersPacksDashboard';
import WidgetDashboard from './components/WidgetDashboard';
import CommonI18Dashboard from './common-i18-dashboard-page/components/CommonI18DashboardIndex';
import TemplateCustomizer from './components/sm/TemplateCustomizer';
import TemplatesList from './components/sm/TemplatesList';
import TournamentSMBrowser from './components/sm/pages/TournamentSMBrowser';
import TeamSeasonHomeSMB from './components/sm/pages/TeamSeasonHomeSMB';
import TeamSeasonStatsSMB from './components/sm/pages/TeamSeasonStatsSMB';
import TeamSquadSMB from './components/sm/pages/TeamSquadSMB';
import TeamHostSMB from './components/sm/pages/TeamHostSMB';
import PlayerHostSMB from './components/sm/pages/PlayerHostSMB';
import PlayerSeasonSMB from './components/sm/pages/PlayerSeasonSMB';
import PlayerH2HSeasonSMB from './components/sm/pages/PlayerH2HSeasonSMB';
import EventSMB from './components/sm/pages/event/EventSMB';
import EventIncidentsSMB from './components/sm/pages/event/EventIncidentsSMB';
import EventStatsSMB from './components/sm/pages/event/EventStatsSMB';
import EventTeamFormSMB from './components/sm/pages/event/EventTeamFormSMB';
import EventPlayerPerformanceSMB from './components/sm/pages/event/EventPlayerPerformanceSMB';
import EventLineupSMB from './components/sm/pages/event/EventLineupSMB';

import EventHost from './components/sm/pages/event/EventHost';
import EventBookieSMB from './components/sm/pages/event/EventBookieSMB';

import RoundSMB from './components/sm/pages/TournamentRoundSMB';
import TournamentHomeSMB from './components/sm/pages/TournamentHomeSMB';
import TournamentRoundHost from './components/sm/pages/TournamentRoundHost';
import TournamentStageSMB from './components/sm/pages/TournamentStageSMB';
import SportHomeSMBrowser from './components/sm/pages/SportHomeSMBrowser';
import F1HomeSMBrowser from './components/sm/pages/F1HomeSMBrowser';
import F1GPXSMBrowser from './components/sm/pages/F1GPXSMBrowser';
import SMPostPage from './components/sm/SMPostPage';
import SMBrowser, { SMBrowserMenu } from './components/sm/SMBrowser';
import WidgetStats from './components/WidgetStatsByWIID';
import ClientSummary from './components/ClientSummary';
import WidgetsSummary from './components/WidgetsSummary';

import WidgetPortfolio from './portfolio/components/WidgetPortfolio';
// import WidgetEmbed from './editor/components/WidgetEmbed';

import WidgetPickerPage from './widget-picker/containers/WidgetPickerPage';
import WidgetEditPage from './editor/containers/WidgetEditPage';

import { SMLinkManager } from './campaign/containers/SMLink';
import CreateCampaign from './campaign/containers/Campaign/Create';
import EditCampaign from './campaign/containers/Campaign/Edit';
import CampaignList from './campaign/containers/Campaign/List';
import CampaignView from './campaign/containers/Campaign/CampaignView';
import ManualTrigger from './campaign/containers/Campaign/ManualTrigger';
import PostPredictions from './campaign/containers/Campaign/PostPredictions';
import ManualPost from './campaign/containers/Campaign/ManualPost';

import FactsView from './facts/FactsView';

/* IDSFinder */
import IDSTournaments from './components/ids-finder/IDSTournaments';
import IDSTournament from './components/ids-finder/IDSTournament';
import IDSTeam from './components/ids-finder/IDSTeam';
/* end IDSFinder */

/* ProviderIds */
import ProviderIds from './components/provider-ids/ProviderIds';
/* ProviderIds */

import CreateAccount from './admin/components/Account/CreateAccount';
import AccountsList from './admin/components/Account/AccountsList';
import UpdateAccount from './admin/components/Account/UpdateAccount/UpdateAccount';

import Hub from './admin/components/Hub';

import KeyValSS2 from './admin/components/KeyValSS2';

import MessageScene from './messages/components/MessageScene';
import { allPermissionsPresent } from './hoc/withFeature';
import { OddsScene } from 'dash-front/odds';
import TournamentStageHost from 'dash-front/components/sm/pages/TournamentStageHost';
import InterestsUser from './interests-page/components/index';
import { MuiThemeProvider } from 'material-ui/styles';
import darkBaseTheme from 'material-ui/styles/baseThemes/darkBaseTheme';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
injectTapEventPlugin();

const NoMatch = () => <div>Page not found!</div>;

const DarkFullPageContainer = ({ children }) => (
    <MuiThemeProvider muiTheme={getMuiTheme(darkBaseTheme)}>
        <Paper
            style={{
                height: 'calc(100vh - 64px - 30px)', // remove action bar and 2x15 paddings
            }}
        >
            {children}
        </Paper>
    </MuiThemeProvider>
);

function requireAuth(nextState, replace) {
    if (!auth.loggedIn()) {
        replace({
            pathname: '/login',
            state: { nextPathname: nextState.location.pathname },
        });
    }
}

function requireSocialAuth(nextState, replace) {
    // check account for social
    if (!auth.loggedIn()) {
        replace({
            pathname: '/login',
            state: { nextPathname: nextState.location.pathname },
        });
    }
}

var htmlRoot = document.getElementById('root');

const loggedIn = new UserAuthWrapper({
    authSelector: state => state.user,
    wrapperDisplayName: 'UserIsLoggedIn',
    failureRedirectPath: '/login',
});

const isAdmin = new UserAuthWrapper({
    authSelector: state => state.user,
    wrapperDisplayName: 'UserIsLoggedIn',
    failureRedirectPath: '/home',
    predicate: user => some(user.roles, role => role === 'admin'),
});

const hasFeature = features =>
    new UserAuthWrapper({
        authSelector: state => state.user,
        wrapperDisplayName: 'UserHasFeautures',
        failureRedirectPath: '/home',
        predicate: user => allPermissionsPresent(features, user),
    });

if (process.env.NODE_ENV !== 'prod') {
    window.store = store;
} else {
    if (location.protocol !== 'https:') {
        location.protocol = 'https:';
    }
}

if (htmlRoot) {
    ReactDOM.render(
        <Provider store={store}>
            <Router history={browserHistory}>
                <Route component={App}>
                    <Route path="/(login)" component={LoginForm} params={{ disableMiniMenu: true }} />
                    <Route path="/hub" component={loggedIn(Hub)} />
                    <Route
                        path="/key-val-ss2"
                        params={{ disableFooter: true, disableHeader: true, container: 'container-white' }}
                        component={KeyValSS2}
                    />
                    <Route path="/home" component={loggedIn(Home)} />
                    <Route path="/campaigns" params={{ container: 'container' }} component={loggedIn(CampaignList)} />
                    <Route path="/campaigns/social" component={loggedIn(SMLinkManager)} />
                    <Route
                        path="/campaigns/create"
                        params={{ container: 'container' }}
                        component={loggedIn(CreateCampaign)}
                    />
                    <Route
                        path="/campaigns/edit/:campaignId"
                        params={{ container: 'container' }}
                        component={loggedIn(EditCampaign)}
                    />
                    <Route
                        path="/campaigns/view/:campaignId/prediction"
                        params={{ container: 'container' }}
                        component={loggedIn(PostPredictions)}
                    />
                    <Route
                        path="/campaigns/view/:campaignId(/:tab)"
                        params={{ container: 'container' }}
                        component={loggedIn(CampaignView)}
                    />
                    <Route path="/campaigns/manual-trigger" component={loggedIn(ManualTrigger)} />
                    <Route
                        path="/campaigns/manual-post(/:campaignId)(/:widgetId)"
                        component={loggedIn(ManualPost)}
                        params={{ container: 'container-white' }}
                    />
                    <Route path="/interests" params={{ container: 'container' }} component={loggedIn(InterestsUser)} />
                    <Route
                        path="/messages"
                        params={{ container: 'container-white' }}
                        component={loggedIn(hasFeature('messageServices')(MessageScene))}
                    />
                    <Route path="/faq" component={loggedIn(FAQ)} />
                    <Route path="/i18" component={loggedIn(I18)} />
                    <Route path="/stats" component={loggedIn(WidgetListStats)} />
                    <Route path="/summary/client" component={loggedIn(ClientSummary)} />
                    <Route path="/summary/widgets" component={loggedIn(WidgetsSummary)} />
                    <Route path="/account" params={{ container: 'container-white' }} component={loggedIn(Account)} />
                    <Route
                        path="/account/defaults"
                        params={{ container: 'container-white' }}
                        component={loggedIn(AccountDefaults)}
                    />
                    <Route
                        path="/account/password"
                        params={{ container: 'container' }}
                        component={loggedIn(AccountPassword)}
                    />
                    <Route path="/widgets/pick" params={{ container: 'container' }} component={loggedIn(WidgetPick)} />
                    <Route path="/widgets/create/:widgetId" component={loggedIn(WidgetCustomizer)} />
                    <Route path="/widgets/:widgetId/customize" params={{ disableFooter: true }} onEnter={requireAuth} />
                    <Route
                        path="/widgets/:widgetId/customizer"
                        params={{ disableFooter: true }}
                        component={loggedIn(WidgetCustomizer)}
                    />
                    <Route path="/widgets/:wiid/statistics" component={loggedIn(WidgetStats)} />
                    <Route path="/widgets/:widgetId/demo" component={loggedIn(WidgetDemo)} />

                    <Route
                        path="/themes"
                        params={{ container: 'container-white', isHidden: false }}
                        component={loggedIn(ThemesList)}
                    />
                    <Route
                        path="/themes/hidden"
                        params={{ container: 'container-white', isHidden: true }}
                        component={loggedIn(ThemesList)}
                    />
                    <Route
                        path="/themes/:themeId/customize"
                        params={{ disableFooter: true }}
                        component={loggedIn(ThemeCustomizer)}
                    />
                    <Route
                        path="/themes/:themeId/customizer"
                        params={{ disableFooter: true }}
                        component={loggedIn(ThemeCustomizer)}
                    />
                    <Route
                        path="/themes/:themeId/customizer/:widgets"
                        params={{ disableFooter: true }}
                        component={loggedIn(ThemeCustomizer)}
                    />
                    <Route path="/widgets/:widgetId/show-case/:name" component={loggedIn(WidgetDemo)} />

                    <Route
                        path="/sm/templates"
                        params={{ disableFooter: true, container: 'container-white', isHidden: false }}
                        component={loggedIn(TemplatesList)}
                    />
                    <Route
                        path="/sm/templates/hidden"
                        params={{ disableFooter: true, container: 'container-white', isHidden: true }}
                        component={loggedIn(TemplatesList)}
                    />
                    <Route
                        path="/sm/templates/create"
                        params={{ disableFooter: true }}
                        component={loggedIn(TemplateCustomizer)}
                    />
                    <Route path="/sm/templates/edit" params={{ disableFooter: true }} component={TemplateCustomizer} />

                    <Route path="/portfolio">
                        <IndexRedirect to="default" />
                        <Route path=":type" component={WidgetPortfolio} />
                    </Route>

                    <Route path="/editor" component={loggedIn(DarkFullPageContainer)}>
                        <IndexRedirect to="pick/all" />
                        <Route path="pick" components={WidgetPickerPage} />
                        <Route path="pick/:tab" components={WidgetPickerPage} />
                        <Route path=":widgetId/:tab" components={WidgetEditPage} />
                        <Route path=":widgetId">
                            <IndexRedirect to="layout" />
                        </Route>
                    </Route>

                    <Route
                        path="/sm/browser"
                        params={{ doubleAppBar: true }}
                        components={{ main: SMBrowser, menu: SMBrowserMenu }}
                        onEnter={requireSocialAuth}
                    >
                        <Route
                            path="post"
                            component={loggedIn(SMPostPage)}
                            params={{ container: 'container', disableTemplateChange: true }}
                        />

                        <Route
                            path="post/:widgetId"
                            component={loggedIn(SMPostPage)}
                            params={{ container: 'container', disableTemplateChange: true }}
                        />

                        <Route path="f1" component={loggedIn(F1HomeSMBrowser)} params={{ sport: 'f1' }} />
                        <Route path="f1/:gpId" component={loggedIn(F1GPXSMBrowser)} params={{ sport: 'f1' }} />
                        <Route path="f1/gpx/:gpId" component={loggedIn(F1GPXSMBrowser)} params={{ sport: 'f1' }} />
                        <Route path=":sport" component={loggedIn(SportHomeSMBrowser)} />
                        <Route
                            path=":sport/tournaments/:tournamentId"
                            params={{ doubleAppBar: true }}
                            components={loggedIn(TournamentSMBrowser)}
                            onEnter={requireSocialAuth}
                        >
                            <Route path=":seasonId">
                                <Route path="team/:teamId" components={loggedIn(TeamHostSMB)}>
                                    <Route path="home" component={loggedIn(TeamSeasonHomeSMB)} />
                                    <Route path="stats" component={loggedIn(TeamSeasonStatsSMB)} />
                                    <Route path="squad">
                                        <IndexRoute component={loggedIn(TeamSquadSMB)} />
                                        <Route path="players/:playerId" components={loggedIn(PlayerHostSMB)}>
                                            <Route path="home" component={loggedIn(PlayerSeasonSMB)} />
                                            <Route path="compare" component={loggedIn(PlayerH2HSeasonSMB)} />
                                        </Route>
                                    </Route>
                                </Route>

                                <Route path="stages/:stageId" component={loggedIn(TournamentStageHost)}>
                                    <Route path="rounds/:round" component={loggedIn(TournamentRoundHost)}>
                                        <Route path="events/:eventId" component={loggedIn(EventHost)}>
                                            <Route path="home" component={loggedIn(EventSMB)} />
                                            <Route path="stats" component={loggedIn(EventStatsSMB)} />
                                            <Route path="incidents" component={loggedIn(EventIncidentsSMB)} />
                                            <Route path="lineup" component={loggedIn(EventLineupSMB)} />
                                            <Route path="bookie" component={loggedIn(EventBookieSMB)} />
                                            <Route path="team-form" component={loggedIn(EventTeamFormSMB)} />
                                            <Route
                                                path="best-players"
                                                component={loggedIn(EventPlayerPerformanceSMB)}
                                            />
                                            <Route
                                                path=":other"
                                                component={({ params }) => (
                                                    <h1>{params.other} page is under construction</h1>
                                                )}
                                            />
                                            <IndexRoute component={loggedIn(EventSMB)} />
                                        </Route>
                                        <IndexRoute component={loggedIn(RoundSMB)} />
                                    </Route>
                                    <IndexRoute component={loggedIn(TournamentStageSMB)} />
                                </Route>
                                <IndexRoute component={loggedIn(TournamentHomeSMB)} />
                            </Route>
                            <IndexRedirect to="current" />
                        </Route>
                    </Route>
                    <Route
                        path="/facts"
                        params={{ disableFooter: true, container: 'container-white' }}
                        component={loggedIn(FactsView)}
                    />
                    <Route
                        path="/media/uploads"
                        params={{ disableFooter: true, container: 'container-white' }}
                        component={loggedIn(ImageUploaderContainer)}
                    />
                    <Route
                        path="/ids-finder/:sport/tournaments"
                        params={{ container: 'container-white' }}
                        component={loggedIn(IDSTournaments)}
                    />
                    <Route
                        path="/ids-finder/:sport/tournaments/:tournamentId"
                        params={{ container: 'container-white' }}
                        component={loggedIn(IDSTournament)}
                    />
                    <Route
                        path="/ids-finder/:sport/teams/:teamId"
                        params={{ container: 'container-white' }}
                        component={loggedIn(IDSTeam)}
                    />
                    <Route
                        path="/mapping/:source"
                        params={{ container: 'container-white' }}
                        component={loggedIn(ProviderIds)}
                    />
                    <Route
                        path="/tv-program"
                        params={{ container: 'container-white' }}
                        component={loggedIn(TvProgramDashboard)}
                    />
                    <Route
                        path="/grid-maker-tool"
                        component={loggedIn(GridMakerToolPage)}
                        params={{ container: 'container-white' }}
                    />
                    <Route path="/admin/packs" component={loggedIn(PacksScene)}>
                        <Route path=":packId" component={Pack} />
                        <IndexRoute component={PacksList} />
                    </Route>
                    <Route path="/admin/users-packs" component={loggedIn(UsersPacksDashboard)} />
                    <Route path="/admin/widgets-dashboard(/:widgetId)" component={loggedIn(WidgetDashboard)} />
                    <Route path="/admin/common-i18-dashboard" component={loggedIn(CommonI18Dashboard)} />
                    <Route
                        path="/ppi"
                        component={loggedIn(PlayerPerformanceIndex)}
                        params={{ container: 'container-white' }}
                    />
                    <Route
                        path="/admin/accounts/edit/:username"
                        params={{ container: 'container-white' }}
                        component={loggedIn(isAdmin(UpdateAccount))}
                    />
                    <Route
                        path="/admin/accounts/create"
                        params={{ container: 'container-white' }}
                        component={loggedIn(isAdmin(CreateAccount))}
                    />
                    <Route
                        path="/admin/accounts"
                        params={{ container: 'container-white' }}
                        component={loggedIn(isAdmin(AccountsList))}
                    />
                    <Route path="/odds(/:eventId)" component={OddsScene} />
                    <Route path="*" component={NoMatch} />
                </Route>
            </Router>
        </Provider>,
        htmlRoot,
    );
}



/** WEBPACK FOOTER **
 ** ../src/dash/front/index.js
 **/